@if (studentBooking) {
  <form #bookingForm="ngForm">
    <div>
      <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:mb-12">
        @if (componentViewMode != 'View') {
          <div class="tw:w-full tw:px-[15px] tw:mb-12">
            <div class="tile-padding-first">
              <div class="app-nav-back-btn tw:mx-1 tw:float-left" (click)="backClick()">Back</div>
            </div>
          </div>
        }
        <div class="tw:w-full tw:px-[15px] tw:md:w-1/2 tw:lg:w-5/12">
          <h3 class="tw:my-0 tw:mb-4">{{ componentViewMode == "View" ? "Lesson summary" : "Add lesson summary" }}</h3>
        </div>
        <div class="tw:w-full tw:px-[15px] tw:md:w-1/2 tw:lg:w-7/12 session-status">
          <div class="tw:my-0">
            <label class="tw:mb-6 tw:mr-4">Status: </label>
            <span class="tag">{{ studentBooking.status }}</span>
          </div>
        </div>
      </div>
      <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:mb-6">
        <div class="tw:flex-1 tw:px-[15px] date-picker-container-max-width">
          <div class="tw:flex tw:flex-wrap tw:-mx-[15px]">
            <div class="tw:w-full tw:px-[15px] tw:mb-4">
              <div class="tw:flex session-date-container">
                <div class="tw:flex tw:flex-wrap tw:p-0 tw:m-0 tw:w-full tw:flex-nowrap">
                  <div class="tw:flex-1 tw:p-0 tw:m-0 tw:pl-4 tw:py-2 session-date-date-part">
                    <label class="tw:mb-6">Date</label>
                    <label>
                      {{ studentBooking.startDate | date: "dd MMM yyyy" }}
                    </label>
                  </div>
                  <div class="tw:p-0 tw:m-0 tw:py-2 tw:flex-1 session-date-time-part">
                    <label class="tw:mb-6">Start</label>
                    <label>
                      {{studentBooking.startTime.length > 5 ? studentBooking.startTime.slice(0, -3) :
                      studentBooking.startTime }}
                    </label>
                  </div>
                  <div class="tw:p-0 tw:m-0 tw:mr-auto tw:py-2 tw:flex-1 session-date-time-part">
                    <label class="tw:mb-6">Finish</label>
                    <label>
                      {{ studentBooking.endTime.length > 5 ? studentBooking.endTime.slice(0, -3) : studentBooking.endTime
                      }}
                    </label>
                  </div>
                  <div class="tw:p-0 tw:m-0">
                    <button type="button" class="btn-primary panel-button tw:px-6" name="NewDate" value="NewDate"
                      (click)="newSessionDateClicked()" [disabled]="!newSessionDateButtonEnabled()">
                      Select Date
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="tw:w-full tw:px-[15px] tw:mt-6">
              <label class="field__label">Subject:</label>
              <select class="field__control tw:w-full" [(ngModel)]="studentBooking.subject" name="subject">
                @for (subject of subjects; track subject) {
                  <option [value]="subject.text">{{ subject.text }}</option>
                }
              </select>
            </div>
          </div>
        </div>
        <div class="tw:w-full tw:px-[15px] tw:lg:flex-1 tw:mb-6">
          <label class="field__label">Lesson Objectives:
            @if (studentCommentsMandatory && !(studentBooking.lessonSummary && studentBooking.lessonSummary.length >= 100)) {
              <i class="tw:text-danger font-10"
                >(mandatory
              - {{studentBooking.lessonSummary?.length || 0}}/100 required)</i>
            }</label>
            <textarea #lessonSummary class="field__control tw:w-full" [(ngModel)]="studentBooking.lessonSummary" name="summary" rows="7"
              maxlength="3000"></textarea>
            <span class="field__hint tw:block tw:text-right">{{ studentBooking.lessonSummary?.length || 0 }}/3000</span>
          </div>
        </div>
        <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:mb-4">
          <div class="tw:w-full tw:px-[15px]">
            <div class="flex-row">
              <div class="flex-column">
                <div class="student-details-header">
                  <h3 class="tw:p-0 tw:m-0">Learners</h3>
                  <div class="group-tab" (click)="addGroupLearningSection()">
                    Add Group Learning Section
                  </div>
                </div>
                @for (student of bookingStudents; track student; let i = $index) {
                  <div class="student-details-container">
                    <student-booking-student-details [(model)]="bookingStudents[i]" [studentIndex]="i"
                      [disabled]="!this.isFormEditable()" [status]="studentBooking.status"
                      [placementId]="studentBooking.placementId"
                      [clientId]="studentBooking.clientId" (onDataChanged)="studentModelUpdated($event, i)"
                      [lockStudents]="lockStudents" [commentsMandatory]="studentCommentsMandatory"
                      [subject]="studentBooking.subject" [(studentIds)]="studentIds"
                      (studentChanged)="studentIdChanged($event)" #studentDetails>
                    </student-booking-student-details>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
        <div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:mb-6">
          <div class="tw:flex-1 tw:px-[15px]">
            @if ( featureHelperService.hasFeature('IndividualLearningReportsSave') && !featureHelperService.hasFeature('TutorReportsSave')) {
              <div
                class="div-padding-right-10 div-flex-buttons div-flex-buttons--right div-flex-buttons--gap-8">
                <button type="submit" class="btn btn-primary" name="SaveDraft" value="Save" (click)="saveClicked()"
                  [disabled]="!saveSubmitButtonEnabled()">
                  Save
                </button>
                <button type="submit" class="btn btn-primary" name="Submit" value="Submit" (click)="submitClicked()"
                  [disabled]="!saveSubmitButtonEnabled()">
                  Submit
                </button>
                <button type="button" class="btn btn-primary" name="Delete Session" value="Delete" (click)="deleteClicked()"
                  [disabled]="!deleteButtonVisible()">
                  Delete
                </button>
                @if (approveButtonVisible()) {
                  <button type="submit" class="btn btn-primary" name="Approve" value="Approve" (click)="approveClicked()"
                    >
                    Approve
                  </button>
                }
                @if (unlockButtonVisible()) {
                  <button type="submit" class="btn btn-primary" name="Unlock" value="Unlock" (click)="unlockClicked()"
                    >
                    Unlock
                  </button>
                }
              </div>
            }
            @if (featureHelperService.hasFeature('TutorReportsSave')) {
              <div
                class="div-padding-right-10 div-flex-buttons div-flex-buttons--right div-flex-buttons--gap-8">
                <button type="submit" class="btn btn-primary" name="SaveDraft" value="Save" (click)="saveClicked()"
                  [disabled]="!saveSubmitButtonEnabled()">
                  Save
                </button>
                <button type="submit" class="btn btn-primary" name="Submit" value="Submit" (click)="submitClicked()"
                  [disabled]="!saveSubmitButtonEnabled()">
                  Submit
                </button>
                <button type="button" class="btn btn-primary" name="Delete Session" value="Delete" (click)="deleteClicked()"
                  [disabled]="!deleteButtonVisible()">
                  Delete
                </button>
                @if (approveButtonVisible()) {
                  <button type="submit" class="btn btn-primary" name="Approve" value="Approve" (click)="approveClicked()"
                    >
                    Approve
                  </button>
                }
                @if (rejectButtonVisible()) {
                  <button type="submit" class="btn btn-primary" name="Reject" value="Reject" (click)="rejectClicked()"
                    >
                    Reject
                  </button>
                }
                @if (unlockButtonVisible()) {
                  <button type="submit" class="btn btn-primary" name="Unlock" value="Unlock" (click)="unlockClicked()"
                    >
                    Unlock
                  </button>
                }
              </div>
            }
          </div>
        </div>
      </div>
    </form>
  }